export default __webpack_public_path__ + "static/media/Help.cb6f827a.svg";